module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/ring.a800f631.mp4";